/*eslint-disable*/
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  namespaced: true,
  state: {
    userinfo: {},
    showDataImgs: {},
    showLoad: true,//加载状态
    appData: {},//申请内容详情
  },
  mutations: {
    setUserInfo(state, userInfo) { //个人信息
      state.userinfo = userInfo;
    },
    setDataImgs(state, DataImgs) { // 图片预览
      state.showDataImgs = DataImgs;
    },
    setShowLoad(state, loadType) {//控制加载动画

      state.showLoad = loadType;
    },
    setAppData(state, data) { //申请内容详情
      state.appData = data;
    }
  },
  actions: {}
})